import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { Colors } from "../../../helpers/Colors";
import { fontSize } from "../../../helpers/fontSize";
import { TiUserAdd } from "react-icons/ti";
import { CgExtension } from "react-icons/cg";
import axios from "axios";
import toast from "react-hot-toast";
import { ax_addCabin } from "../../../api/cabin";

const useStyles = makeStyles({
  AddEmployee: {
    backgroundColor: Colors.primaryLight,
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  Employee: {
    display: "flex",
    flexDirection: "column",
    // backgroundColor: Colors.primary,

    // --------- from xs(380px) till md(770px)
    "@media only screen and (max-Width: 770px)": {
      padding: "5px 10px",
      // backgroundColor: Colors.error,
    },
    // --------- from md(770px) till xl(1200px)
    "@media (min-width: 770px) and (max-width: 1200px)": {
      padding: "10px 40px",
      // backgroundColor: Colors.secondary,
    },
    // --------- from xl(1200px) to above screen
    "@media only screen and (min-width: 1200px)": {
      padding: "10px 120px",
      // backgroundColor: Colors.logo8,
    },
    fontSize: fontSize.question,
    "& .Header": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      fontWeight: 600,
      boxShadow: `0px 3px 10px ${Colors.primaryMedium}`,
      "& .number": {
        width: "auto",
        height: "auto",
        padding: "8px 15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.primary,
        // borderRadius: "20px",
        "& .iconCon": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // cursor: "pointer",
          "& .icon": {
            width: "25px",
            height: "26px",
          },
        },
      },
      "& .question_chevron": {
        width: "100%",
        // display: "flex",
        // alignItems: "center",
        // justifyContent: "space-between",
        backgroundColor: Colors.white,
        padding: "0px 15px",
        "& .question": {
          padding: "8px",
          //   backgroundColor: "blue",
        },
        "& .rightCon": {
          display: "flex",
          padding: "8px 0px 8px 8px",
          "& .selected": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 500,
            fontSize: fontSize.selected,
            color: Colors.grey,
            "& span": {
              margin: "0px 5px",
              color: Colors.success,
              // color: (props) => props.cabinName === Cabins.cabin1 ? `${Colors.tom}` :  `${Colors.jerry}`,
            },
          },
          "& .iconCon": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // cursor: "pointer",
            "& .icon": {
              width: "25px",
              height: "25px",
            },
          },
        },
      },
    },
    "& .Body": {
      "& .BodyCon": {
        padding: "20px",
        // --------- from xs(380px) till md(770px)
        "@media only screen and (max-Width: 770px)": {
          padding: "8px",
        },
        "& .allTimes": {
          display: "flex",
          flexDirection: "row",
          width: "fit-content",
          padding: "10px",
        },
      },
    },
  },
  DetailsCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    "@media only screen and (max-Width: 430px)": {
      overflow: "scroll",
      height: "600px",
    },
  },
  Cabin_Date: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    // backgroundColor: Colors.tyke,
    width: "38rem",
    // --------- from xs(380px) till md(770px)
    "@media only screen and (max-Width: 770px)": {
      // flexDirection: "column",
      width: "29rem",
    },
    "@media only screen and (max-Width: 430px)": {
      flexDirection: "column",
      width: "100%",
    },
    // // --------- from md(770px) till xl(1200px)
    // "@media (min-width: 770px) and (max-width: 1200px)": {
    //   padding: "10px 40px",
    //   // backgroundColor: Colors.secondary,
    // },
    // // --------- from xl(1200px) to above screen
    // "@media only screen and (min-width: 1200px)": {
    //   padding: "10px 120px",
    //   // backgroundColor: Colors.logo8,
    // },
    "& .Cabin": {
      // backgroundColor: Colors.tom,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      flexDirection: "column",
      width: "280px",
      padding: "0 0 8px 0",
      // --------- from xs(380px) till md(770px)
      "@media only screen and (max-Width: 770px)": {
        width: "220px",
      },
      "& label": {
        fontSize: fontSize.label,
        color: Colors.greySteel,
        fontWeight: 500,
        margin: "0px",
        padding: "0px",
      },
      "& input, select": {
        width: "100%",
        padding: "5px 10px",
        color: Colors.secondary,
        // fontWeight: 400,
        fontSize: fontSize.reservationDetails,
        borderRadius: "5px",
        border: `1px solid ${Colors.primary}`,
        backgroundColor: Colors.white,
        outline: "none",

        // Hide the arrows button for input["number"]
        "&::-webkit-outer-spin-button": {
          margin: 0,
          WebkitAppearance: "none",
        },
        "&::-webkit-inner-spin-button": {
          margin: 0,
          WebkitAppearance: "none",
        },
        "&[type=number]": {
          MozAppearance: "textfield",
        },
      },
      //       /* Chrome, Safari, Edge, Opera */
      // input::-webkit-outer-spin-button,
      // input::-webkit-inner-spin-button {
      //   -webkit-appearance: none;
      //   margin: 0;
      // }

      // /* Firefox */
      // input[type=number] {
      //   -moz-appearance: textfield;
      // }
    },
  },
});

const AddCabin = ({ triggerUseEffect, setUseEffect }) => {
  const classes = useStyles();

  const [cabinName, setCabinName] = useState("");
  const [maxCapacity, setMaxCapacity] = useState("");
  const [level, setLevel] = useState("");
  const [buildingName, setBuildingName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPincode] = useState("");
  const [country, setCountry] = useState("");

  const onAddCabinHandler = async (e) => {
    e.preventDefault();
    if (
      cabinName !== "" &&
      maxCapacity !== "" &&
      level !== "" &&
      buildingName !== "" &&
      city !== "" &&
      state !== "" &&
      pincode !== "" &&
      country !== ""
    ) {
      const data = {
        cabinName,
        maxCapacity,
        level,
        buildingName,
        city,
        state,
        pincode,
        country,
      };

      try {
        const ax = await ax_addCabin(data);
        console.log("ax --> " + JSON.stringify(ax));
        if (ax.code === 200) {
          setCabinName("");
          setMaxCapacity("");
          setLevel("");
          setBuildingName("");
          setCity("");
          setState("");
          setPincode("");
          setCountry("");
          setUseEffect(true);
          ax.key === "Success"
            ? toast.success(ax.description)
            : toast.error(ax.description);
        }
      } catch (e) {
        console.log("Error from AddCabin:", e);
      }
    } else {
      toast.error("All Fields are required!");
    }
  };

  return (
    <section className={classes.Employee}>
      <main
        className="Header"
        //   onClick={onCabinHeaderClick}
      >
        <section className="number">
          <div className="iconCon">
            <TiUserAdd className="icon" />
          </div>
        </section>
        <section className="question_chevron">
          <div className="question">Add a Cabin</div>
        </section>
      </main>
      <form onSubmit={onAddCabinHandler} className="Body">
        <section className="BodyCon">
          <section className={classes.DetailsCon}>
            <section className={classes.Cabin_Date}>
              {/* Cabin_Name */}
              <div className="Cabin">
                <label>Cabin Name</label>
                <input
                  className=""
                  type={"text"}
                  placeholder={"Chennai"}
                  value={cabinName}
                  onChange={(e) => setCabinName(e.target.value)}
                />
              </div>
              {/* Max_Capacity */}
              <div className="Cabin">
                <label>Max Capacity</label>
                <input
                  className=""
                  type={"number"}
                  placeholder={"7"}
                  value={maxCapacity}
                  onChange={(e) => setMaxCapacity(e.target.value)}
                />
              </div>
            </section>
            <section className={classes.Cabin_Date}>
              {/* Level */}
              <div className="Cabin">
                <label>Level</label>
                <input
                  className=""
                  type={"text"}
                  placeholder={"Level 10"}
                  value={level}
                  onChange={(e) => setLevel(e.target.value)}
                />
              </div>
              {/* Building_Name */}
              <div className="Cabin">
                <label>Building Name</label>
                <input
                  className=""
                  type={"text"}
                  placeholder={"Workafella"}
                  value={buildingName}
                  onChange={(e) => setBuildingName(e.target.value)}
                />
              </div>
            </section>
            <section className={classes.Cabin_Date}>
              {/* city */}
              <div className="Cabin">
                <label>City</label>
                <input
                  className=""
                  type={"text"}
                  placeholder={"Chennai"}
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </div>
              {/* state */}
              <div className="Cabin">
                <label>State</label>
                <input
                  className=""
                  type={"text"}
                  placeholder={"Tamil Nadu"}
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                />
              </div>
            </section>
            <section className={classes.Cabin_Date}>
              {/* pincode */}
              <div className="Cabin">
                <label>Pin Code</label>
                <input
                  className=""
                  type={"number"}
                  placeholder={"603202"}
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                />
              </div>
              {/* country */}
              <div className="Cabin">
                <label>Country</label>
                <select
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                >
                  <option id="default" defaultValue>
                    Choose a Country
                  </option>
                  <option id="IND" value={"IND"}>
                    India
                  </option>
                  <option id="USA" value={"USA"}>
                    United States
                  </option>
                </select>
              </div>
            </section>
          </section>
        </section>
        {/* Add Button */}
        <button
          type="submit"
          className="flex items-center justify-end bg-primary w-fit p-2 rounded-md float-right cursor-pointer outline-none"
          // onClick={slideToDatePrevious}
        >
          <div className="flex items-center justify-center">
            <CgExtension className="w-6 h-6" />
          </div>
          <div className="text-base font-semibold px-1">Add a Cabin</div>
        </button>
      </form>
    </section>
  );
};

export default AddCabin;
